import {useFieldValue} from 'components/hook-form/useFieldValue';

// export function useValues<T>([...keys]: (keyof T)[], prefix?: string) {
//    const {values} = useFormikContext();
//    let vals: T = values as T;
//    if (prefix) {
//       vals = get(values, prefix) as T;
//    }
// }

export const useValues = useFieldValue;
